export { fetchSinglePageData } from "./fetchSinglePageData";
